import { RoutingService } from 'src/app/security/services/routing.service';
import { LocalService } from './../../../services/local.service';
import { UserInfo } from './../../../security/models/user-info';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { SecurityService } from '../../../security/services/security.service';
import { Router } from '@angular/router';
import { ContractEntityService } from 'src/app/services';
import { UserDataVeh } from 'src/app/models/views/user-data-veh';
import { SecurityHelperService } from 'src/app/security/services/security-helper.service';
import { VulnerableActivityEnum } from 'src/app/enums';

@Component({
  selector: 'app-header-secure',
  templateUrl: './header-secure.component.html',
  styleUrls: ['./header-secure.component.css'],
})
export class HeaderSecureComponent implements OnInit {
  userInfo: UserInfo = new UserInfo();
  isAdmin: boolean = false;
  isUser: boolean = false;
  isClient: boolean = false;
  userData: UserDataVeh = new UserDataVeh();

  constructor(
    private securityService: SecurityService,
    private localService: LocalService,
    private routingService: RoutingService,
    private securityHelperService: SecurityHelperService,
    private router: Router,
    @Inject('ALDDA_MX_URL') public alddaMxUrl: string,
    @Inject('IMAGES_URL') public imagesUrl: string,
    private contractEntityService: ContractEntityService
  ) {}

  ngOnInit() {
    this.loadUserInfo();
    this.contractEntityService.getUserDataVeh().subscribe((response) => (this.userData = response));
  }

  loadUserInfo() {
    this.securityService.getUserInfo().subscribe((res: UserInfo) => {
      this.userInfo = res;
    });
  }

  logOut() {
    this.securityService.signOut();
  }

  goToProfile() {
    this.routingService.navigateToProfile();
  }
  
  goToSO() {
    this.routingService.navigateToSO();
  }

  goToHelpCenter(){
    const token = this.securityHelperService.token;
    const subjectObligedId = this.securityHelperService.subjectObligedId;    
    window.open(`${this.alddaMxUrl}#/login?subjectId=${subjectObligedId}&token=${token}&requestType=helpCenter&originType=${VulnerableActivityEnum.VEH}`, '__blank');
  }

}
